import React, { useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';

import MentionSuggestion from './MentionSuggestion';

import styles from './styles.module.less';

const DEBOUNCING_TIME = 275; // in milliseconds

const AutoresizeMentionTextarea = props => {
  const [timeoutId, setTimeoutId] = useState(undefined);
  const [suggestionsList, setSugguestionsList] = useState([]);

  const {
    value,
    onChange,
    placeholder,
    fetch,
    textRef,
    onFocus,
    onKeyDown,
    debouncingTime,
  } = props;

  const getUsersList = (query, callback) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(async () => {
        setTimeoutId(undefined);

        const result = await fetch(query);

        setSugguestionsList(result);
        callback(result);
      }, debouncingTime || DEBOUNCING_TIME)
    );

    callback(suggestionsList);
  };

  // Renders the mention in the text input
  const displayTransform = (_id, display) => {
    return `@${display}`;
  };

  // Renders the suggestion list per <li/>
  const renderSuggestion = user => {
    return <MentionSuggestion user={user} />;
  };

  return (
    <MentionsInput
      allowSpaceInQuery={true}
      allowSuggestionsAboveCursor={true}
      className="mentionWrapper"
      classNames={styles}
      inputRef={textRef}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      singleLine={false}
      value={value}
      placeholder={placeholder}
    >
      <Mention
        appendSpaceOnAdd={true}
        className={styles.mention}
        data={getUsersList}
        displayTransform={displayTransform}
        markup={'@[__display__](__id__)'}
        renderSuggestion={renderSuggestion}
        trigger="@"
      />
    </MentionsInput>
  );
};

export default AutoresizeMentionTextarea;
